import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { DashboardTasksRoutes } from '@repo/shared/routes-dashboard-tasks'
import { AxiosInstance } from 'axios'

import { IDashboardTasksApi } from '@/spi/api/dashboard-tasks'

export const buildDashboardTasksApi = (axios: AxiosInstance): IDashboardTasksApi => ({
  getAll: async (params) => {
    const res = await tryCatch(async () =>
      axios.get<typeof DashboardTasksRoutes.getAll.response>(
        DashboardTasksRoutes.getAll.getPath(params),
      ),
    )
    if (hasError(res)) return handleError(res)
    return res.data
  },
})
